<div class="spinner-main">
    <div class="spinner-main__content">
        <div class="spinner-main__content__item"></div>
        <div class="spinner-main__content__item"></div>
        <div class="spinner-main__content__item"></div>
    </div>
</div>
